Auth = require 'app/scripts/db/auth'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
{ CustomSticker } = require 'app/scripts/models/CustomSticker'

class CustomStickerList extends CollectionWithHelpers
  model: CustomSticker
  url: -> "/1/member/#{ Auth.me().id }/customStickers"

  initialize: (list, { @member }) ->

module.exports = CustomStickerList
